var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "capacity-calendar" },
    [
      _c("capacity-filter-bar", {
        attrs: {
          "active-time-period": _vm.activeTimePeriod,
          "date-string": _vm.dateString,
          "hidden-weekdays": _vm.hiddenWeekDays,
          "selected-due-in-out": _vm.selectedDueInOut,
          theme: _vm.theme,
        },
        on: {
          arrowClick: _vm.handleArrowClick,
          changeActive: _vm.handleReportChange,
          changeShowWeekend: _vm.handleChangeShowWeekend,
        },
      }),
      _c(
        "div",
        { staticClass: "is-flex", staticStyle: { height: "93%" } },
        [
          _c("calendar-component", {
            attrs: {
              "calendar-arr": _vm.calendarArr,
              "is-monthly": _vm.isMonthly,
              "active-time-period": _vm.activeTimePeriod,
              "weekly-side-time-bar": _vm.weeklySideTimeBar,
              "number-of-days": 7 - _vm.hiddenWeekDaysFiltered.length,
              "min-time": _vm.minTime,
              "max-time": _vm.maxTime,
              "hidden-weekdays": _vm.hiddenWeekDaysFiltered,
              "is-side-panel-open": _vm.sidePanelObj.isSidePanelOpen,
              "selected-cell": _vm.sidePanelObj.selectedCell,
              "selected-cell-date-str": _vm.sidePanelObj.sidePanelDateStr,
              "is-loading": _vm.isDataLoading,
            },
            on: {
              openModal: _vm.openModal,
              handleCellClick: _vm.handleCellClick,
            },
          }),
        ],
        1
      ),
      _c(
        "aside",
        {
          staticClass: "booking-panel",
          class: {
            closed: !_vm.sidePanelObj.isSidePanelOpen,
            open: _vm.sidePanelObj.isSidePanelOpen,
          },
        },
        [
          _c("booking-page-side-panel", {
            attrs: {
              "quote-data": _vm.quoteData,
              "is-side-panel-open": _vm.sidePanelObj.isSidePanelOpen,
              "selected-cell": _vm.sidePanelObj.selectedCell,
            },
            on: {
              handleDragEvent: _vm.handleDragEvent,
              handleQuoteDag: _vm.handleQuoteDag,
              handleSidePanelToggle: _vm.handleSidePanelToggle,
              clearSelectedCell: function ($event) {
                _vm.selectedCell = null
              },
              handleQuoteRedirect: _vm.handleQuoteRedirect,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }